module.exports = __webpack_public_path__ + "img/USD.0e711240.png";